export default {
  FOOD: 'food',
  GLASS: 'glass',
  PAPER: 'paper'
};


/** WEBPACK FOOTER **
 ** ./examples/01 Dustbin/Multiple Targets/ItemTypes.js
 **/